import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-brand-primary max-w-4xl h-1 text-center border-2 border-brand-primary mx-auto" }
const _hoisted_2 = { class: "max-w-prose mx-auto text-xl text-gray-700 font-gotham-bold text-center py-2" }

import Hero from '../components/content/Hero.vue';
import HeroBanner from '../components/content/HeroBanner.vue';
import Features from '../components/content/Features.vue';
import Container from '../components/content/Container.vue';
import HelpOptions from '../components/content/HelpOptions.vue';
import PlanSelector from '../components/ordering/PlanSelector.vue';
import Title from '../components/content/Title.vue';
import { injectStrict } from '@/plugins/vueServiceContainerPlugin';
import { BrandServiceInterface } from '@/services/brand/brandServiceInterface';
import { Address, AutocompleteAddressAdapterInterface } from '@/adapters/autocompleteAddressAdapterInterface';
import { Ref, ref } from 'vue';
import { ServiceQualificationAdapterInterface } from '@/adapters/serviceQualificationAdapterInterface';
import store from '@/store';
import router from '@/router';
import { Brand } from '../services/integration/enums';
import { useGtm } from '@gtm-support/vue-gtm';
import HispFeatures from '@/components/content/HispFeatures.vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const gtm = useGtm();

const autocompleteAddressAdapter = injectStrict<AutocompleteAddressAdapterInterface>('AutocompleteAddressAdapterInterface');
const serviceQualificationAdapter = injectStrict<ServiceQualificationAdapterInterface>('ServiceQualificationAdapterInterface');
const brandService = injectStrict<BrandServiceInterface>('BrandServiceInterface');

const featuresData = brandService.getFeaturesData();
const contacts = brandService.getContacts();
const products = brandService.getDefaultPlanSelectorProducts();

// Data.
const address = ref('');
const autocompletedAddresses: Ref<Array<Address>> = ref([]);
const selectedAddress: Ref<Address|undefined> = ref();

// Event handlers.
const unitiRedirect = async () => {
  if (brandService.getName() === Brand.JAM) {
    router.push('/uniti');
  }
};

unitiRedirect();
const handleAddressSearchInputted = async (inputAddress: string) => {
  // When the user types into the address search field, fetch addresses from sq.
  address.value = inputAddress;
  const addresses = await autocompleteAddressAdapter.autocompleteAddress(inputAddress);
  autocompletedAddresses.value = addresses;
};

const handleAutocompletedAddressClicked = (autocompletedAddress: Address) => {
  // When a user clicks an address, set it as the address in the input.
  address.value = autocompletedAddress.address;
  selectedAddress.value = autocompletedAddress;
  autocompletedAddresses.value = [];
};

const handleCheckAddressClicked = async (inputAddress: string, done: () => void) => {
  // When the user submits an address.
  if (selectedAddress.value) {
    // Do SQ.
    const serviceQualification = await serviceQualificationAdapter.serviceQualification(selectedAddress.value);

    if (serviceQualification !== null) {
      // Save SQ to store.
      store.commit('setServiceQualification', serviceQualification);

      if (gtm) {
        gtm.trackEvent({
          event: 'SQ_ADDRESS_CLICKED',
          category: 'SHOPPING',
          action: 'click',
          label: 'SQ ADDRESS SEARCH',
          noninteraction: false,
          state: serviceQualification.state,
          carrier: serviceQualification.carrier
        });
      }

      // Change page.
      router.push('/sign-up');
    } else {
      if (gtm) {
        gtm.trackEvent({
          event: 'SQ_NOT_SERVICEABLE',
          category: 'SHOPPING',
          action: 'click',
          label: 'SQ NOT SERVICEABLE',
          noninteraction: false
        });
      }
      router.push('/not-serviceable');
    }
  } else {
    done();
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(HeroBanner, {
      announcement: _unref(brandService).getHomeAnnouncement()
    }, null, 8, ["announcement"]),
    _createVNode(Hero, {
      "autocompleted-addresses": autocompletedAddresses.value,
      address: address.value,
      onOnAutocompletedAddressClicked: handleAutocompletedAddressClicked,
      onOnCheckAddressClicked: handleCheckAddressClicked,
      onOnAddressSearchInputted: handleAddressSearchInputted
    }, null, 8, ["autocompleted-addresses", "address"]),
    _createVNode(Container, { class: "bg-white" }, {
      default: _withCtx(() => [
        _withDirectives(_createVNode(Features, {
          class: "pt-20 mb-20",
          features: _unref(featuresData).features,
          header: _unref(featuresData).header,
          id: "features"
        }, null, 8, ["features", "header"]), [
          [_vShow, _unref(brandService).getName() !== _unref(Brand).HIS]
        ]),
        _withDirectives(_createVNode(HispFeatures, {
          class: "pt-20 mb-20",
          features: _unref(featuresData).features,
          header: _unref(featuresData).header,
          id: "features"
        }, null, 8, ["features", "header"]), [
          [_vShow, _unref(brandService).getName() === _unref(Brand).HIS]
        ]),
        _withDirectives(_createElementVNode("hr", _hoisted_1, null, 512), [
          [_vShow, _unref(brandService).getName() === _unref(Brand).HIS]
        ]),
        _createVNode(Title, {
          class: "mt-20",
          title: _unref(brandService).getName() !== _unref(Brand).HIS ? 'Our plans.' : 'Our Internet Plans',
          centered: true,
          id: "plans"
        }, null, 8, ["title"]),
        _withDirectives(_createElementVNode("p", _hoisted_2, " Powered by Opticomm ", 512), [
          [_vShow, _unref(brandService).getName() === _unref(Brand).HIS]
        ]),
        _createVNode(PlanSelector, {
          class: "mt-12 mb-20",
          canSelectProduct: false,
          products: _unref(products),
          selected: ''
        }, null, 8, ["products"]),
        _createVNode(Title, {
          class: "mt-20 mb-4",
          title: "How can we help?",
          centered: true,
          id: "contact"
        }),
        _createVNode(HelpOptions, {
          class: "pb-20",
          features: _unref(contacts)
        }, null, 8, ["features"])
      ]),
      _: 1
    })
  ], 64))
}
}

})